import { IconClose } from "../../icon/variants/IconClose.js";
import { IconSearch } from "../../icon/variants/IconSearch.js";
import { IconButton } from "../../icon-button/IconButton.js";
import { VerticalDivider } from "../../divider/variants/VerticalDivider.js";
import { TextInput as TextInput$1 } from "../text-input/TextInput.js";
import { Flex } from "@mantine/core";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/components/inputs/search-input/SearchInput.tsx
const SearchInput = ({ autoFocus, clear, description, disabled, error, inputMode, label, name, onBlur, onChange, onClick, onFocus, onKeyUp, onPaste, placeholder, required, type, value, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(TextInput$1, {
		autoFocus,
		description,
		disabled,
		error,
		inputMode,
		label,
		name,
		onBlur,
		onChange,
		onClick,
		onFocus,
		onKeyUp,
		onPaste,
		placeholder,
		required,
		type,
		value,
		"data-testid": testId,
		role: "searchbox",
		rightSection: /* @__PURE__ */ jsxs(Flex, {
			direction: "row",
			gap: "xs",
			mr: "xs",
			children: [value ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(IconButton, {
				color: "gray",
				withStyles: false,
				Icon: IconClose,
				onClick: clear
			}), /* @__PURE__ */ jsx(VerticalDivider, {})] }) : null, /* @__PURE__ */ jsx(Flex, {
				align: "center",
				children: /* @__PURE__ */ jsx(IconSearch, {})
			})]
		})
	});
};

//#endregion
export { SearchInput };